module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Cacahuate_Blanqueado_Entero.7fec4355.pdf";